export default __webpack_public_path__ + "static/media/SAS Alert Tone 9.bab96e92.wav";